type ProgressBarProps = {
  /*	The height of the progress bar in number. */
  height: number;
  /*	The progress value from 0 to 100. */
  progress: number;
  /*	The color of the progress bar. */
  color?: string;
};

const ProgressBar = ({
  progress,
  height,
  color = "var(--color-icon-positive-default)",
}: ProgressBarProps) => {
  return (
    <div
      className="ps-w-full ps-rounded-full ps-bg-gray-200"
      style={{ height: `${height}px` }}
    >
      <div
        className="ps-rounded-full"
        style={{
          width: `${progress}%`,
          height: `${height}px`,
          backgroundColor: color,
          transition: "width 1s ease-in-out",
        }}
      />
    </div>
  );
};

export default ProgressBar;
